import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'

export const container = css`
  min-height: 100vh;
  background-color: ${colors.black};
  color: ${colors.white100};
  padding-top: 125px; /* Decreased from 140px to reduce gap further */
`

export const tabContent = css`
  flex: 1;
  overflow-y: auto;
`

export const loadingContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.white100};
`

export const errorContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${colors.red};
` 